export default "assets/images/texture_darkbleu-d3210831.jpg";